import axios from '@axios'

export default {
  listAreas: () => axios.get(`${process.env.VUE_APP_WCOND_API}/areas`),
  listAreasDisponiveis: (date, unidade) => axios.get(`${process.env.VUE_APP_WCOND_API}/areas/${date}?u=${unidade ? unidade.id : ''}`),
  listEventos: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/calendario/${pagina}`),
  listMeusEventos: pagina => axios.get(
    `${process.env.VUE_APP_WCOND_API}/calendario/minhasreservas/${pagina}`,
  ),
  getEvento: eventoId => axios.get(`${process.env.VUE_APP_WCOND_API}/evento`, {
    id: eventoId,
  }),
  deleteEvento: eventoId => axios.delete(`${process.env.VUE_APP_WCOND_API}/evento/${eventoId}`),
  solicitarSuplencia: (eventoId, unidadeId) => axios.get(`${process.env.VUE_APP_WCOND_API}/evento/${eventoId}/suplencia/${unidadeId}`),
  postPreparaTermo: evento => axios.post(`${process.env.VUE_APP_WCOND_API}/evento/termodeuso`, {
    ...evento,
  }),
  postEvento: evento => axios.post(`${process.env.VUE_APP_WCOND_API}/evento/v2`, {
    ...evento,
  }),
  listSuplencias: eventoId => axios.get(`${process.env.VUE_APP_WCOND_API}/calendario/reservas/${eventoId}/suplencias`),
}
